import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { IUserSessionComponentProps } from '../../../../models/AppState';
import { Checkbox } from '../../../../web/components/Checkbox';
import { DayPicker } from '../../../../web/components/DayPicker';
import { DeprecatedCloseButton } from '../../../../web/components/DeprecatedCloseButton';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../web/components/Popover';
import { DefaultSelectBox, ISelectBoxOption } from '../../../../web/components/SelectBox';
import { TextInput } from '../../../../web/components/TextInput';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IExpirationDisplayProps extends IUserSessionComponentProps {
	campaignExpires?: boolean;
	selectedExpirationMoment?: moment.Moment;
	readonly?: boolean;
	setExpirationDay: (day: any) => void;
	onTimeOptionSelected: (option: ISelectBoxOption<number>) => void;
	validSelectedHour: ISelectBoxOption<number>;
	timeOptions: ISelectBoxOption<number>[];
	onExpiryChanged: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ExpirationDisplay({
	selectedExpirationMoment,
	campaignExpires,
	readonly,
	timeOptions,
	validSelectedHour,
	onTimeOptionSelected,
	setExpirationDay,
	onExpiryChanged,
}: IExpirationDisplayProps) {
	const expirationDate = selectedExpirationMoment?.toDate();
	const [showingPopover, setShowingPopover] = React.useState(false);
	return (
		<Checkbox
			id='add-expiry-checkbox'
			onChange={onExpiryChanged}
			disabled={readonly}
			checked={campaignExpires === true}
			className={css(styleSheet.expirationContainer)}
		>
			<span className={css(styleSheet.feature)}>This is a time-sensitive campaign - stop sending after</span>
			{campaignExpires ? (
				<Popover open={showingPopover} onOpenChange={setShowingPopover}>
					<PopoverTrigger asChild>
						<button>
							<TextInput
								className={css(styleSheet.expirationDateInput)}
								placeholder={expirationDate ? expirationDate.toLocaleDateString() : 'mm/dd/yyyy'}
								type='text'
								inputId='reports-month-filter'
								readOnly={true}
							/>
						</button>
					</PopoverTrigger>
					<PopoverContent>
						<div className={css(styleSheet.dayPickerPopoverContent)}>
							<div className={css(styleSheet.dayPickerPopoverHeader)}>
								<DeprecatedCloseButton onClick={() => setShowingPopover(false)} />
							</div>
							<DayPicker defaultSelectedDay={new Date()} onDayClick={setExpirationDay} selectedDays={expirationDate} />
							{timeOptions?.length > 0 && (
								<div className={css(styleSheet.dayPickerPopoverTime)}>
									<DefaultSelectBox
										className={css(styleSheet.dayPickerPopoverTimeDropDown)}
										menuPopupPosition='top'
										onSelectionChanged={onTimeOptionSelected}
										options={timeOptions}
										optionStyles={[styleSheet.dayPickerPopoverTimeDropdownOption]}
										placeholder={<span className={css(styleSheet.timeDropdownPlaceholder)}>Select a time...</span>}
										selectedOption={validSelectedHour}
										triggerStyles={[styleSheet.dayPickerPopoverTimeDropdownTrigger]}
									/>
								</div>
							)}
							<div className={css(styleSheet.dayPickerPopoverFooter)}>
								<button className={css(baseStyleSheet.ctaButtonSmall)} onClick={() => setShowingPopover(false)}>
									<span>Confirm Expiration Date</span>
								</button>
							</div>
						</div>
					</PopoverContent>
				</Popover>
			) : null}
		</Checkbox>
	);
}
